import { ConditionalWrapper, useTranslation } from '@presentation/utils';
import type { LocationDescriptor } from 'history';
import type { FC } from 'react';
import { FaChevronLeft } from 'react-icons/fa';

import { Container, Label } from '..';
import * as Styled from './styled';
import type { HeaderProfileProps } from './types';

export * from './types';

export const HeaderProfile: FC<HeaderProfileProps> = (props) => {
  const {
    title,
    subtitle,
    onBackClick,
    children,
    tagsPrefix,
    tags,
    backLink,
    bg,
    withWhatsapp = false,
    ...rest
  } = props;
  const { translate } = useTranslation();

  return (
    <Styled.Banner {...rest} withWhatsapp={withWhatsapp} src={bg}>
      <Container>
        {(!!onBackClick || !!backLink) && (
          <ConditionalWrapper
            condition={!!backLink}
            wrapper={(wrapperChildren) => (
              <Styled.ForegroundLink to={backLink as LocationDescriptor}>
                {wrapperChildren}
              </Styled.ForegroundLink>
            )}
          >
            <Styled.BackWrapper onClick={onBackClick}>
              <FaChevronLeft />
              <div>{translate('common.buttons.back')}</div>
            </Styled.BackWrapper>
          </ConditionalWrapper>
        )}
        {!!title && <Styled.Title>{title}</Styled.Title>}

        {!!subtitle && <Styled.Subtitle>{subtitle}</Styled.Subtitle>}

        {!!tags && !!tags.length && (
          <Styled.TagsWrapper>
            {!!tagsPrefix && <Styled.TagsPrefix>{tagsPrefix}</Styled.TagsPrefix>}
            <Styled.TagContainer>
              {tags.map((tag, index) => (
                <Label
                  key={index}
                  theme={tag.theme}
                  bgColor={tag.bgColor}
                  onClick={tag.onClick}
                  content={tag.content}
                />
              ))}
            </Styled.TagContainer>
          </Styled.TagsWrapper>
        )}

        {children}
      </Container>
    </Styled.Banner>
  );
};
